import React, { Component } from "react";
import '../Styles/Home.css'

export default class Home extends Component {
  render() {
    return (
        <section id="home" className="home">
          <div 
            className="info-container"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <p className="small-text">Olá, meu nome é</p>
            <h1 className="title-home">Lucas Chavarem</h1>
            <div>
              <h1 className="title-home1 border-aux typing-animation" > Desenvolvedor
                <span className="stack"> Full-Stack.</span>
              </h1>
            </div>
            <p className="text-description-home">
              Eu sou um desenvolvedor web full-stack, <br/>
              formado pela escola de programação 
              <a 
                href="https://www.betrybe.com/formacao-desenvolvimento-web"
                className="trybe-link"
                target="_blank"
                rel="noreferrer"
              > Trybe.
              </a> 
              <br />
              Gostaria de conhecer alguns dos meus projetos?
            </p>
            <div className="cv-container">
            <a
              href="https://bit.ly/lucaschavarem_cv"
              className="cv-button"
              target="_blank"
              rel="noreferrer"
            >
              Baixar CV
            </a>
          </div>
          </div>
        </section>
    )
  }
}
